// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"761":"QQShare","857":"WxLaunchHack"}[chunkId] || chunkId) + "." + {"67":"fc1d9d55e0","761":"c4ebb754c8","857":"f366d92ad5"}[chunkId] + ".js";
};